import { render } from "./SaveSystemUser.vue?vue&type=template&id=3ac29caa"
import script from "./SaveSystemUser.vue?vue&type=script&lang=js"
export * from "./SaveSystemUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__